import get from 'lodash.get';

const getPartnerBrandedFooter = (rootState) =>
  get(rootState, 'user.partnerData.properties.wsBranding.siteFooter', null);

export default getPartnerBrandedFooter;
